import LazyLoad from "vanilla-lazyload";
import Toggler from "~/classes/Toggler";
import BrowserDetect from "~/classes/BrowserDetect";
import SubMenu from "~/classes/SubMenu";
import MobileMenu from "~/classes/MobileMenu";
import StickyMenu from "~/classes/StickyMenu";
import flatpickr from "flatpickr";
import { German } from 'flatpickr/dist/l10n/de';
import { Spanish } from 'flatpickr/dist/l10n/es';
import { French } from 'flatpickr/dist/l10n/fr';
import { Dutch } from 'flatpickr/dist/l10n/nl';
import { Italian } from 'flatpickr/dist/l10n/it';
import { Portuguese } from 'flatpickr/dist/l10n/pt';
import GoToTopButton from "~/classes/GoToTopButton";
switch (document.documentElement.lang) {
    case 'nl-NL':
    case 'nl-BE':
        flatpickr.localize(Dutch);
        break;
    case 'pt-PT':
        flatpickr.localize(Portuguese);
        break;
    case 'it-IT':
        flatpickr.localize(Italian);
        break;
    case 'es-ES':
        flatpickr.localize(Spanish);
        break;
    case 'fr-FR':
    case 'fr-BE':
        flatpickr.localize(French);
        break;
    case 'de-AT':
    case 'de-CH':
    case 'de-DE':
    case 'ch':
        flatpickr.localize(German);
        break;
}
const lazyLoader = new LazyLoad({
// Your custom settings go here
});
class Application {
    constructor() {
        // Content jumping scripts first
        new BrowserDetect();
        this.initReadMore();
        this.initProviderCarousel();
        this.initAirportReviewsCarousel();
        this.initQuestionPage();
        this.initSubMenus();
        this.initMobileMenu();
        this.initScrollToHandler();
        this.initFlashMessage();
        this.initCookieWall();
        this.initCookieSwitch();
        this.initTogglers();
        this.initParkingGallery();
        this.initParkingMoreReviews();
        this.initParkingForm();
        this.initPoppers();
        this.initPopUp();
        this.initContactForm();
        this.initStarScore();
        this.initQuestions();
        this.initKallables();
        this.initGoogleMapsTrigger();
        this.initParkingReviews();
        this.initParkingSearchs();
        this.initExternalParkingSearch();
        this.initExternalParkingDetails();
        this.initCompare();
        this.initParkingBooking();
        this.initCheckoutForm();
        this.initCheckoutSuccess();
        this.initCheckoutSummary();
        this.initWindowBlur();
        this.initTableScrollbars();
        this.initConsentManager();
        new StickyMenu();
        new GoToTopButton();
    }
    initTogglers() {
        const elements = document.querySelectorAll('.js-toggle');
        if (elements !== null && elements.length > 0) {
            for (let element of elements) {
                new Toggler(element);
            }
        }
    }
    initSubMenus() {
        const elements = document.querySelectorAll('.js-sub-menu');
        if (elements !== null && elements.length > 0) {
            for (let element of elements) {
                new SubMenu(element);
            }
        }
    }
    initMobileMenu() {
        const element = document.querySelector('.js-mobile-menu');
        if (element !== null) {
            new MobileMenu(element, lazyLoader);
        }
    }
    initScrollToHandler() {
        const elements = document.querySelectorAll('.js-scroll-to-target');
        if (elements !== null && elements.length > 0) {
            import(/* webpackChunkName: "scrollToHandler" */ "~/classes/ScrollToHandler").then(({ default: ScrollToHandler }) => {
                new ScrollToHandler(elements);
            });
        }
    }
    initFlashMessage() {
        const element = document.querySelector('.js-flash-message');
        if (element !== null) {
            import(/* webpackChunkName: "flashMessage" */ "~/classes/FlashMessage").then(({ default: FlashMessage }) => {
                new FlashMessage(element);
            });
        }
    }
    initCookieWall() {
        const element = document.querySelector('.js-cookie-wall');
        if (element !== null) {
            import(/* webpackChunkName: "cookieWall" */ "~/classes/CookieWall").then(({ default: CookieWall }) => {
                new CookieWall(element);
            });
        }
    }
    initCookieSwitch() {
        const element = document.querySelector('.js-cookie-switch');
        if (element !== null) {
            import(/* webpackChunkName: "cookieSwitch" */ "~/classes/CookieSwitch").then(({ default: CookieSwitch }) => {
                new CookieSwitch(element);
            });
        }
    }
    initConsentManager() {
        const element = document.querySelector('.js-consent-manager');
        if (element !== null) {
            import(/* webpackChunkName: "cookieWall" */ "~/classes/ConsentManager").then(({ default: ConsentManager }) => {
                new ConsentManager(element);
            });
        }
    }
    initProviderCarousel() {
        const element = document.querySelector('.js-provider-carousel');
        if (element !== null) {
            import(/* webpackChunkName: "providerCarousel" */ "~/classes/ProviderCarousel").then(({ default: ProviderCarousel }) => {
                new ProviderCarousel();
            });
        }
    }
    initAirportReviewsCarousel() {
        const element = document.querySelector('.js-airport-reviews-carousel');
        if (element !== null) {
            import(/* webpackChunkName: "providerCarousel" */ "~/classes/AirportReviewsCarousel").then(({ default: AirportReviewsCarousel }) => {
                new AirportReviewsCarousel();
            });
        }
    }
    initParkingMoreReviews() {
        const element = document.querySelector('.js-more-reviews');
        if (element !== null) {
            import(/* webpackChunkName: "parkingMoreReviews" */ "~/classes/ParkingMoreReviews").then(({ default: ParkingMoreReviews }) => {
                new ParkingMoreReviews(element);
            });
        }
    }
    initParkingForm() {
        const elements = document.querySelectorAll('.js-partner-form');
        if (elements !== null && elements.length > 0) {
            import(/* webpackChunkName: "partnerForm" */ "~/classes/PartnerForm").then(({ default: PartnerForm }) => {
                for (let element of elements) {
                    new PartnerForm(element);
                }
            });
        }
    }
    initPoppers() {
        const elements = document.querySelectorAll('.js-popper');
        if (elements !== null && elements.length > 0) {
            import(/* webpackChunkName: "popper" */ "~/classes/Popper").then(({ default: Popper }) => {
                for (let element of elements) {
                    new Popper(element);
                }
            });
        }
    }
    initPopUp() {
        const element = document.querySelector('.js-pop-up');
        if (element !== null) {
            import(/* webpackChunkName: "popUp" */ "~/classes/PopUp").then(({ default: PopUp }) => {
                new PopUp(element);
            });
        }
    }
    initContactForm() {
        const element = document.querySelector('.js-contact-form');
        if (element !== null) {
            import(/* webpackChunkName: "contact" */ "~/classes/ContactForm").then(({ default: ContactForm }) => {
                new ContactForm(element);
            });
        }
    }
    initReadMore() {
        const elements = document.querySelectorAll('.js-read-more');
        if (elements !== null && elements.length > 0) {
            import(/* webpackChunkName: "readMore" */ "~/classes/ReadMore").then(({ default: ReadMore }) => {
                for (let element of elements) {
                    new ReadMore(element);
                }
            });
        }
    }
    initStarScore() {
        const elements = document.querySelectorAll('.js-start-score');
        if (elements !== null && elements.length > 0) {
            import(/* webpackChunkName: "starScore" */ "~/classes/StarScore").then(({ default: StarScore }) => {
                for (let element of elements) {
                    new StarScore(element);
                }
            });
        }
    }
    initQuestions() {
        const elements = document.querySelectorAll('.js-question');
        if (elements !== null && elements.length > 0) {
            import(/* webpackChunkName: "questions" */ "~/classes/Question").then(({ default: Question }) => {
                for (let element of elements) {
                    new Question(element);
                }
            });
        }
    }
    initQuestionPage() {
        const element = document.querySelector('.js-question-page');
        if (element !== null) {
            import(/* webpackChunkName: "questionPage" */ "~/classes/QuestionPage").then(({ default: QuestionPage }) => {
                new QuestionPage(element);
            });
        }
    }
    initKallables() {
        const elements = document.querySelectorAll('.js-kal');
        if (elements !== null && elements.length > 0) {
            import(/* webpackChunkName: "kallables" */ "~/classes/Kallable").then(({ default: Kallable }) => {
                for (let element of elements) {
                    new Kallable(element);
                }
            });
        }
    }
    initGoogleMapsTrigger() {
        const element = document.querySelector('.js-map-trigger');
        if (element !== null) {
            import(/* webpackChunkName: "googleMapsTrigger" */ "~/classes/GoogleMapsTrigger").then(({ default: GoogleMapsTrigger }) => {
                new GoogleMapsTrigger(element);
            });
        }
    }
    initParkingReviews() {
        const element = document.querySelector('.js-parking-reviews');
        if (element !== null) {
            import(/* webpackChunkName: "parkingReviews" */ "~/classes/ParkingReviews").then(({ default: ParkingReviews }) => {
                new ParkingReviews(element);
            });
        }
    }
    initParkingSearchs() {
        const elements = document.querySelectorAll('.js-parking-search');
        if (elements !== null && elements.length > 0) {
            import(/* webpackChunkName: "parkingSearch" */ "~/classes/ParkingSearch").then(({ default: ParkingSearch }) => {
                for (let element of elements) {
                    new ParkingSearch(element);
                }
            });
        }
    }
    initExternalParkingSearch() {
        const element = document.querySelector('.js-external-parking-search');
        if (element !== null) {
            import(/* webpackChunkName: "externalParkingSearch" */ "~/classes/ExternalParkingSearch").then(({ default: ExternalParkingSearch }) => {
                new ExternalParkingSearch(element);
            });
        }
    }
    initExternalParkingDetails() {
        const element = document.querySelector('.js-external-parking-details');
        if (element !== null) {
            import(/* webpackChunkName: "externalParkingDetails" */ "~/classes/ExternalParkingDetails").then(({ default: ExternalParkingDetails }) => {
                new ExternalParkingDetails(element);
            });
        }
    }
    initCompare() {
        const element = document.querySelector('.js-compare');
        if (element !== null) {
            import(/* webpackChunkName: "compare" */ "~/classes/Compare").then(({ default: Compare }) => {
                new Compare(element);
            });
        }
    }
    initParkingBooking() {
        const elements = document.querySelectorAll('.js-parking-booking');
        if (elements !== null && elements.length > 0) {
            import(/* webpackChunkName: "parkingBooking" */ "~/classes/ParkingBooking").then(({ default: ParkingBooking }) => {
                for (let element of elements) {
                    new ParkingBooking(element);
                }
            });
        }
    }
    initParkingGallery() {
        const elements = document.querySelectorAll('.js-glightbox');
        if (elements !== null && elements.length > 0) {
            // @ts-ignore // Note append glightbox in same chunk as parking booking, they are always used at the same time
            import(/* webpackChunkName: "parkingBooking" */ 'glightbox').then(({ default: GLightbox }) => {
                const lightbox = GLightbox({
                    selector: '.js-glightbox',
                    elements: null,
                    touchNavigation: true,
                    loop: true,
                    autoplayVideos: false,
                });
                // @ts-ignore
                if (window._openLightbox !== undefined && window._openLightbox) {
                    lightbox.open();
                }
            });
        }
    }
    initCheckoutForm() {
        const element = document.querySelector('.js-checkout-form');
        if (element !== null) {
            import(/* webpackChunkName: "checkout" */ "~/classes/CheckoutForm").then(({ default: CheckoutForm }) => {
                new CheckoutForm(element);
            });
        }
    }
    initCheckoutSuccess() {
        const element = document.querySelector('.js-checkout-success');
        if (element !== null) {
            import(/* webpackChunkName: "checkout" */ "~/classes/CheckoutSuccess").then(({ default: CheckoutSuccess }) => {
                new CheckoutSuccess(element);
            });
        }
    }
    initCheckoutSummary() {
        const element = document.querySelector('.js-checkout-summary');
        if (element !== null) {
            import(/* webpackChunkName: "checkout" */ "~/classes/CheckoutSummary").then(({ default: CheckoutSummary }) => {
                new CheckoutSummary(element);
            });
        }
    }
    initWindowBlur() {
        const pageTitle = window.document.title;
        // @ts-ignore
        const showAttention = window.showAttentionWhenBlur;
        if (showAttention == 'true') {
            window.addEventListener('load', (event) => {
                setTimeout(() => {
                    if (document.visibilityState == "visible")
                        window.document.title = pageTitle;
                    else
                        window.document.title = '(1) ' + pageTitle;
                    document.addEventListener("visibilitychange", event => {
                        if (document.visibilityState == "visible")
                            window.document.title = pageTitle;
                        else
                            window.document.title = '(1) ' + pageTitle;
                    });
                }, 2000);
            });
        }
    }
    initTableScrollbars() {
        const elements = document.querySelectorAll('table:not([data-fixed])');
        if (elements !== null && elements.length > 0) {
            import(/* webpackChunkName: "tableScroller" */ "~/classes/TableScroller").then(({ default: TableScroller }) => {
                for (let element of elements) {
                    new TableScroller(element);
                }
            });
        }
    }
}
new Application();
window.addEventListener("load", () => {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.register("/sw.js");
    }
});
